import { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';

// Redux.
import { connect } from 'react-redux';

// Firebase.
import { getAnalytics, logEvent } from "firebase/analytics";

// Components.
import { loadTrack } from '../components/audioHelper';
import AudioPlayerDrawer from '../components/AudioPlayerDrawer';
import RecentlyPlayed from '../components/RecentlyPlayed';
import BottomMenu from '../components/BottomMenu';
import SigninRequired from '../components/SigninRequired';


const Played = ({
    authenticated,
}) => {

    const [showAudioPlayerDrawer, setShowAudioPlayerDrawer] = useState(false);
    const [selectionModeActive, setSelectionModeActive] = useState(false);
    const trackInfoRef = useRef(null)

    useEffect(() => {
        const analytics = getAnalytics();
        logEvent(analytics, 'screen_view', {
            firebase_screen: 'played'
        });
    }, []);

    const playTrack = (trackInfo, startSeconds) => () => {
        trackInfoRef.current = trackInfo;
        loadTrack(trackInfo.mp3URL, startSeconds);
        setShowAudioPlayerDrawer(true);
    };
    const closeAudioPlayer = () => {
        setShowAudioPlayerDrawer(false);
    }

    if (authenticated !== true) {
        return <SigninRequired authenticated={authenticated} />;
    } else {
        return (
            <div className={`container appScreen ${selectionModeActive ? '' : 'hasBottomMenu'}`.trim()}>
                <AudioPlayerDrawer
                        open={showAudioPlayerDrawer}
                        onClose={closeAudioPlayer}
                        source={trackInfoRef.current ? trackInfoRef.current.source : null}
                        trackId={trackInfoRef.current ? trackInfoRef.current.id : null} />
                {!selectionModeActive && <BottomMenu />}
                <div>
                    <RecentlyPlayed
                        playTrack={playTrack}
                        onSelectionModeChange={setSelectionModeActive}
                    />
                </div>
            </div>
        );
    }
}

Played.propTypes = {
    authenticated: PropTypes.bool
}

Played.defaultProps = {

}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(Played);
